<template>
    <div class="list-page">
        <transition name="fade" mode="out-in">
            <div v-if="show" key="list">
                <el-form :inline="true" :model="formInline" ref="formInline" class="demo-form-inline" size="mini"
                    @submit.native.prevent="onSubmit">
                    <el-form-item label="" prop="task_search">
                        <el-input v-model="formInline.task_search" placeholder="请输入任务名称、任务编号搜索" style="width: 220px"
                            clearable @keyup.enter.native="onSubmit"></el-input>
                    </el-form-item>
                    <el-form-item label="" prop="account_search">
                        <ESelect v-model="formInline.account_search" placeholder="账户筛选，支持名称、ID搜索"
                        multiple
                        filterable
                        collapse-tags
                        remote
                        reserve-keyword
                        clearable
                            :remote-method="(query) => remoteMethod(query, 'creator')"
                            :loading="searchAccountLoading"
                            style="width: 220px">
                            <el-option v-for="item in filterAccountOptions" :key="item.id"
                                       :label="item.name + '(' + item.id + ')'" :value="item.id">
                                <span style="float: left">{{ item.name }}（{{ item.id }}）</span>
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="" prop="app_search">
                        <ESelect v-model="formInline.app_search" placeholder="产品筛选，支持名称、ID、包名搜索" style="width: 220px"
                            multiple collapse-tags clearable filterable remote :loading="searchAppLoading"
                            :remote-method="(query) => remoteMethod(query, 'app')">
                            <el-option v-for="item in filterAppOptions" :key="item.subitem_id"
                            :label="item.subproject_name + '(' + item.subproject_id + ')' + '(' + item.subproject_content + ')'" :value="item.subitem_id">
                                <span style="float: left">{{ item.subproject_name }}（{{ item.subproject_id }}）{{item.subproject_content ? `（${item.subproject_content}）` : ''}}</span>
                            </el-option>
                        </ESelect>
                    </el-form-item>

                    <el-form-item label="">
                        <SelectAll :options="isAllowedPlatList" v-model="formInline['plat_ids']" :placeholder="'媒体'"/>
                    </el-form-item>

                    <el-form-item label="" prop="template_id">
                        <ESelect v-model="formInline.template_id" placeholder="模板筛选" style="width: 140px"
                            class="tagswidth" collapse-tags clearable filterable remote multiple>
                            <el-option :label="option.template_name" :value="option.template_id"
                                v-for="option in filterTempOptions" :key="option.template_id">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="" prop="send_status">
                        <el-select v-model="formInline.send_status" placeholder="发送状态" style="width: 100px"
                            collapse-tags clearable filterable multiple>
                            <el-option label="未发送" value="0"></el-option>
                            <el-option label="已发送" value="1"></el-option>
                            <el-option label="发送中" value="2"></el-option>
                            <el-option label="发送失败" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="user_ids" v-show="isHasCreateDepartment">
                        <ESelect v-model="formInline.user_ids" placeholder="归属人" class="select-tags-width" style="width: 150px"
                        clearable filterable multiple collapse-tags>
                            <el-option :label="option.creator" :value="option.uid" v-for="option in filterUserOptions"
                                :key="option.uid">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                    <el-form-item label="" prop="group_id">
                        <ESelect v-model="formInline.group_id" style="width: 175px" collapse-tags filterable multiple
                            :placeholder="'归属人部门'">
                            <el-option :label="option.name" :value="option.id" v-for="option in filterGroupOptions"
                                :key="option.id">
                            </el-option>
                        </ESelect>
                    </el-form-item>


                    <!--生成时间-->
                    <el-form-item label="" prop="range_time">
                        <el-date-picker
                            v-model="formInline.range_time"
                            style="width: 232px"
                            type="daterange"
                            align="center"
                            unlink-panels
                            :clearable="false"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            range-separator="~"
                            start-placeholder="生成开始"
                            end-placeholder="结束时间">
                        </el-date-picker>
                    </el-form-item>



                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading="loading" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '筛选'}">筛选</el-button>
                        <el-button @click="resetForm('formInline')" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '重置筛选'}">重置筛选</el-button>
                        <!-- <el-button @click="handleKill">清除</el-button> -->
                    </el-form-item>
                </el-form>

                <jt-table :data="tableData" style="width: 100%" stripe
                    :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini" class="create_vivo_list"
                    :row-class-name="tableRowClassName" v-loading="loading" tooltip-effect="dark">
                    <el-table-column label="任务编号" width="80" prop="task_number">
                        <template slot-scope="scope">
                            <span>{{ scope.row.task_number || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="任务名称" min-width="140" prop="task_name">
                        <template slot-scope="scope">
                            <span class="text-color-primary pointer" @click="handlePushInfo(scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '任务详情'}">{{ scope.row.task_name || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="plat_names"
                        label="媒体"
                        align="center"
                        min-width="100">
                        <template slot-scope="scope">
                            <span>{{ scope.row.plat_names || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="生成状态" min-width="180" align="center" prop="generate_status">
                        <template slot-scope="scope">
                            <div>
                                <p>
                                    <span class="mr10">成功(<span class="text-color-success">{{scope.row.generate_status.success}}</span>)</span>
                                    失败(<span class="text-color-error">{{scope.row.generate_status.fail}}</span>)
                                </p>
                                <p>
                                    <span class="mr10"> 进行中(<span>{{scope.row.generate_status.inProgress}}</span>)</span>
                                    未开启(<span>{{scope.row.generate_status.unExecuted}}</span>)
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="生成时间" min-width="100" prop="generate_time">
                        <template slot-scope="scope">
                            <span>{{ scope.row.generate_time || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="生成耗时" min-width="100" prop="total_time">
                        <template slot-scope="scope">
                            <span v-if="scope.row.total_time==='0'||scope.row.total_time===0">0秒</span>
                            <span v-else-if="!scope.row.total_time">--</span>
                            <span v-else>{{secondToDuration(scope.row.total_time)||'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发送状态" min-width="100" prop="send_status">
                        <template slot-scope="scope">
                            <span v-if="scope.row.send_status == 1" class="text-color-success">已发送</span>
                            <span v-else-if="scope.row.send_status == 2" class="text-color-warn">发送中</span>
                            <span v-else-if="scope.row.send_status == 3" class="pointer">
                                <el-tooltip class="item" effect="dark" placement="top">
                                    <span class="mr4 text-color-failed">发送失败
                                        <i class="el-icon-warning-outline text-color-failed"></i>
                                    </span>
                                    <div slot="content" style="max-width: 500px;max-height: 300px;overflow-y: auto;" class="break-word">
                                        <div v-if="scope.row.send_error_info" v-html="scope.row.send_error_info"></div>
                                        <span v-else>发送失败</span>
                                    </div>
                                </el-tooltip>
                            </span>
                            <span v-else>未发送</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发送时间" min-width="90" prop="send_time">
                        <template slot-scope="scope">
                            <span>{{ scope.row.send_time || '--' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="邮件信息" min-width="90">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text"
                                @click="handleClick(scope.$index, scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(邮件信息)'}">查看</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="归属人" min-width="90" prop="creator">
                        <template slot-scope="scope">
                            <span>{{ scope.row.creator || '--' }}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="操作" min-width="100" align="center" fixed="right">
                        <template slot-scope="scope">
                            <div v-if="pageFuncNames.includes('daily_task_button')">
                                <el-button size="mini" type="text" :disabled="scope.row.sendLoading"
                                @click="handleSend(scope.$index, scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(发送)'}">发送</el-button>
                                <el-button size="mini" type="text"
                                @click="handleDown(scope.$index, scope.row)" v-matomo="{behaviorCategory: '自动化报告(任务生成记录)', event: '点击',  name: '列表(下载)'}">下载</el-button>
                            </div>
                            <span v-else>--</span>
                        </template>
                    </el-table-column>
                </jt-table>

                <div style="text-align: center; padding-top: 20px">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>

                <ErrTipModal ref="errTipModal"/>
            </div>
            <div v-else key="info">
                <InfoPage :head="msg" @goback="handleGoback" :page-func-names="pageFuncNames" :allowedPlatList="allowedPlatList"/>
            </div>
        </transition>
        <MailInfoModal ref="mailInfoModal" :data="actionRow" :type="actionType" @update="inin" />
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import InfoPage from "./infoPage.vue"
import SelectAll from '@/components/SelectAll';
import MailInfoModal from './modal/mailInfoModal';
import ErrTipModal from '../../modal/errorTipModal';
import {
    getTemplateSelectUser,
    getTemplateSelecGroup,
} from '@/api/efficiencyTool/template.js'
import {
    getTemplateSelecOptions,
    getRecordSearchTemplateOptions,
    getTemplateRecordList,
    getTemplateRecordLisItems,
    getTemplateRecordListDown,
    getTemplateRecordEmail,
} from '@/api/efficiencyTool/record.js'
import utils from '@/libs/utils.js';
export default {
    name: "efficiencyTool_record_list",
    props: {
        pageFuncNames: Array,
        pageDimensionNames: Array,
        allowedPlatList:Array
    },
    components: {
        InfoPage,
        MailInfoModal,
        ErrTipModal,
        SelectAll
    },
    data() {
        return {
            show: true,
            msg: '',
            actionRow:{},
            actionType:'add',
            filterTempOptions: [],
            filterUserOptions: [],
            filterGroupOptions: [],
            filterAccountOptions: [],
            filterAppOptions: [],
            searchAppLoading:false,
            searchAccountLoading:false,
            formInline: {
                task_id:"",     // 隐藏参数
                task_search: "",    //任务名称
                account_search: [], //账户
                template_id: [],     //模板
                app_search: [],      //产品
                user_ids: [],       //归属人
                group_id: [],       //归属部门
                send_status: [],      //发送状态
                range_time:[],
                plat_ids: []
            },
            loading: false,
            currentPage: 1,
            pageSize: 30,
            total: 10,
            monitor: null, //定时器
            equal: 1, //缓存请求赋值
            tableData: [],
            pickerOptions:{
                firstDayOfWeek: 1,
                disabledDate(time){
                    return time.getTime() > Date.now();
                },
            },
        }
    },
    computed: {
        ...mapGetters(['name','user_id']),
        isHasCreateDepartment() {
            return true
            // return this.pageDimensionNames.includes('create_department');
        },
        isHasBatchCreate() {
            return true
            // return this.pageFuncNames.includes('vivo_batch_create');
        },
        isAllowedPlatList() {
            return this.allowedPlatList.map(item => {return {name:item.name,id:item.id}});
        }
    },
    mounted() {
        this.setRangeTime();
        this.fetchgetList()
    },
    methods: {
        setRangeTime(){
            const date = new Date();
            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 2);
            let endDate = new Date(date.getTime());
            this.formInline.range_time = [utils.formatDate(startDate),utils.formatDate(endDate)];
        },
        fetchgetList() {
            getRecordSearchTemplateOptions().then(res => {
                this.filterTempOptions = res.data
            },err => {
                this.$message.error(err.info);
            })
            getTemplateSelectUser().then(res => {
                this.filterUserOptions = res.data

                if(!this.filterUserOptions.find(item=>item.uid==this.user_id)){
                    this.filterUserOptions.push({
                        uid:this.user_id,
                        creator:this.name,
                    })
                }
                this.resetUserId();
            },err => {
                this.$message.error(err.info);
            })
            getTemplateSelecGroup().then(res => {
                this.filterGroupOptions = res.data
            },err => {
                this.$message.error(err.info);
            })
            // this.inin()
        },
        // renovate() {
        //     this.resetForm('formInline')
        //     let arr = this.isHasCreateDepartment ? ['creator', 'department'] : ['creator']
        //     arr.forEach(item => {
        //         GET_SEARCH_LIST({ search_type: item }).then(res => {
        //             let result = res.data
        //             this[item] = result
        //         })
        //     })
        //     let startDate = dayjs().subtract(6, 'day').format("YYYY-MM-DD");
        //     let endDate = dayjs().format("YYYY-MM-DD");
        //     this.range_time = [startDate, endDate]
        //     this.inin()
        // },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 0) {
                return 'gray-row';
            }
            return '';
        },
        remoteMethod(query, type) {
            if (query == '') {
                return
            }
            if (type == 'creator') {
                this.searchAccountLoading = true
            } else {
                this.searchAppLoading = true
            }
            getTemplateSelecOptions({
                search_type: type,
                search: query,
                source:'record',      // task-任务页面,record-任务记录页面
            }).then(res => {
                let result = res.data
                if (type == 'creator') {
                    this.searchAccountLoading = false
                    this.filterAccountOptions = result
                } else {
                    this.searchAppLoading = false
                    this.filterAppOptions = result
                }
            },err => {
                this.$message.error(err.info);
            })
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            this.inin()
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            this.inin()
        },
        onSubmit() {
            this.handleKill()
            /* task_id为页面跳转时带的隐藏参数，每次筛选时需要清除 */
            this.formInline.task_id = '';
            this.inin()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
            this.resetUserId();

            this.formInline.task_id = ''
            this.formInline.send_status = []
            this.formInline.template_id = []
            this.formInline.account_search = []
            this.formInline.task_search = ''
            this.formInline.plat_ids = []
            this.formInline.group_id = []
            this.formInline.app_search = []
            this.setRangeTime();
            this.currentPage = 1
            this.$nextTick(() => {
                this.inin()
            })
        },
        handlePushInfo(row) {
            this.handleKill()
            this.msg = row
            this.show = false
        },
        // 邮件信息
        handleClick(index, row) {
            this.actionRow = {...row};
            this.actionType = 'view';
            this.$refs.mailInfoModal.showModal();
        },
        // 邮件发送
        handleSend(index, row) {
            row.sendLoading = true;
            getTemplateRecordEmail({
                task_record_id:row.task_record_id,
            }).then(()=>{
                this.actionRow = {...row};
                this.actionType = 'send';
                this.$refs.mailInfoModal.showModal();
                 row.sendLoading = false;
            },err=>{
                // this.$message.error(err.info||'请求失败');
                 row.sendLoading = false;

                if(err.code==403){
                    return this.$message.error(err.info||'请求异常');
                }
                let errData = err.data||{};
                let errList = errData.error_auth||[];
                if(errList.length>0){
                    this.$refs.errTipModal.showModal({
                        title:err.info||'以下账户无权限，无法发送',
                        subTitle:'您可确认权限后重新点击发送，若可忽略无权限文件，重新生成后再次发送即可',
                        actionType:'sendTask',
                        isConfirm:false,
                        errList:errList,
                        actionData:'',
                    });
                }else{
                    this.$message.error(err.info||'请求异常');
                }
            })
        },
        // 下载
        handleDown(index, row) {
            getTemplateRecordListDown({
                task_record_id:row.task_record_id,
                type:'1',
            }).then(res=>{
                let downloadFile = `/td/api//daily_task_record/download?task_record_id=${row.task_record_id}&type=1`
                // this.downloadFile(`/daily_task_record/download?task_record_id=${row.task_record_id}`,'下载')
                utils.exportFile(downloadFile);
            },err=>{
                if(err.code==403){
                    return this.$message.error(err.info||'请求异常');
                }
                let errData = err.data||{};
                let errList = errData.error_auth||[];
                if(errList.length>0){
                    this.$refs.errTipModal.showModal({
                        title:err.info||'以下账户无权限，无法下载',
                        subTitle:'',
                        actionType:'changeTaskDetailStatus',
                        isConfirm:false,
                        errList:errList,
                        actionData:'',
                    });
                }else{
                    this.$message.error(err.info||'操作失败');
                }
            })
        },
        downloadFile(url, filename) {
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.target = '_blank'; // 可选，如果想在新窗口中打开下载链接，请添加此行
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        handleGoback() {
            this.handleKill()
            this.show = true
            this.inin()
        },
        handleClose(done) {

        },
        inin() {
            // this.handleKill()
            let obj = { ...this.formInline, pn: this.currentPage, rn: this.pageSize, }
            obj.department = this.isHasCreateDepartment ? obj.department : '';
            this.loading = true
            obj.range_time = (obj.range_time||[]).join('/');
            this.polling(obj)
        },
        polling(params) {
            getTemplateRecordList(params).then(res => {
                let result = res.data
                let tableList = result.list
                this.loading = false

                let createarr = []
                result.list.forEach(element => {
                    /* send_status==2：发送中的状态也需要刷 */
                    if (element.generate_status.inProgress != 0||element.send_status=='2') {
                        createarr.push(element.task_record_id)
                    }
                });
                // clearTimeout(this.monitor)
                // this.monitor = null
                console.log('createarr', createarr)
                this.tableData = tableList.map(item=>{
                    item.sendLoading = false;
                    return item;
                })
                this.currentPage = result.pageNum
                this.pageSize = result.pageSize
                this.total = result.totalCnt
                if (createarr.length != 0) {
                    let join_arr = createarr.join(',')
                    this.setTableLlisItems({task_record_ids:join_arr})
                }
            },err => {
                this.$message.error(err.info);
            })
        },
        // 设置单独table更新
        setTableLlisItems(query) {
            console.log('query', query)
            getTemplateRecordLisItems(query).then(res=> {
                clearTimeout(this.monitor)
                this.monitor = null
                let addList = res.data
                this.tableData.map(item=>{
                    addList.forEach(ele=> {
                        if(item.task_record_id == ele.task_record_id) {
                            item['total_time'] = ele['total_time']
                            item['generate_status'] = ele['generate_status']
                            item['send_status'] = ele['send_status']
                            item['send_time'] = ele['send_time']
                        }
                    })
                    return item
                })

                let createarr = []
                this.tableData.forEach(element => {
                    /* send_status==2：发送中的状态也需要刷 */
                    if (element.generate_status.inProgress != 0||element.send_status=='2') {
                        createarr.push(element.task_record_id)
                    }
                });
                if (createarr.length != 0) {
                    let join_arr = createarr.join(',')
                    this.monitor = setTimeout(() => { this.setTableLlisItems({task_record_ids:join_arr}) }, 10*1000)
                }
            },err => {
                clearTimeout(this.monitor)
                this.monitor = null
                // this.$message.error(err.info);
            })
        },
        handleKill() {
            for (let i = 1; i < 10; i++) {
                clearTimeout(this.monitor)
                this.monitor = null
                this.equal = 1
            }
        },
        delayedClear() {
            setTimeout(() => {
                for (let i = 1; i < 10; i++) {
                    clearTimeout(this.monitor)
                    this.monitor = null
                    this.equal = 1
                }
            }, 10*1000)
        },
        searchList(data){
            if(!this.show){
                this.show = true;
            }
            /* 从task列表跳转过来时，带着task_id */
            this.formInline.task_search = data.task_name;
            this.formInline.task_id = data.task_id;
            this.formInline.account_search = '';
            this.formInline.app_search = '';
            this.formInline.template_id = '';
            this.formInline.send_status = '';
            // this.formInline.user_ids = '';
            this.formInline.group_id = '';

            this.resetUserId();
            this.inin();
        },
        secondToDuration(val){
            return utils.secondToDuration(val);
        },
        resetUserId(){
            let userData = (this.filterUserOptions||[]).find(item=>item.uid==this.user_id&&item.creator==this.name);
            if(userData){
                this.formInline.user_ids = [userData.uid];
            }else{
                this.formInline.user_ids = [this.user_id];
            }
        },
    },
    deactivated() {
        this.$nextTick(() => {
            this.handleKill()
            this.delayedClear()
        })
    },
    beforeDestroy() {
        this.handleKill()
        this.delayedClear()
    },
    destroyed() {
        this.handleKill()
        this.delayedClear()
    }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.list-page ::v-deep.el-table .gray-row {
    background-color: #f4f4f4;
}

.ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.create_vivo_list tbody .cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline;
}

.demo-form-inline {
    padding: 20px 20px 0;
    background: #f8f8f9;
    margin-bottom: 20px;
}
</style>
<style>
.tagswidth.el-select .el-tag {
    max-width: 70%;
}
</style>
